<template>
  <div>
    <el-upload
      class="avatar-uploader"
      :action="baseUrl"
      :show-file-list="false"
      :style="'width:' + width + 'px;height:' + height + 'px'"
      :class="myUrl ? 'pic' : ''"
      :on-success="handleAvatarSuccess"
      :on-change="onHandelImageSelect"
      :on-error="fail"
      :before-upload="beforeAvatarUpload"
      list-type="picture"
      :on-progress="uploadVideoProcess"
    >
      <el-image
        v-if="myUrl && videoFlag == false && isVideo == true"
        :src="`${myUrl}?vframe/jpg/offset/0`"
        class="avatar"
        fit="fill"
        :class="round ? 'round' : ''"
        :style="'width:' + width + 'px;height:' + height + 'px'"
      />
      <!-- <el-image v-if="myUrl&& videoFlag == false&&isMp3==true" :src="myUrl" class="avatar" fit="fill" :class="round?'round':''" :style="'width:' + width + 'px;height:' + height +'px'" /> -->
      <el-image
        v-else-if="myUrl && videoFlag == false && isVideo == false"
        :src="myUrl"
        class="avatar"
        fit="fill"
        :class="round ? 'round' : ''"
        :style="'width:' + width + 'px;height:' + height + 'px'"
      />
      <i
        v-else-if="!myUrl && videoFlag == false"
        class="el-icon-plus avatar-uploader-icon"
        :style="'font-size:' + width / 4"
      />
      <el-progress
        v-if="videoFlag == true"
        type="circle"
        :percentage="videoUploadPercent"
        style="margin-top: 30px"
      />
    </el-upload>
  </div>
</template>
<script>
/**
 * @imageUrl 当前图片地址或者上传后的图片地址
 * @width 组件的宽度
 */
import environment from '@/utils/environment'
export default {
  props: {
    imageurl: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 40
    },
    height: {
      type: [Number, String],
      default: 40
    },
    round: {
      type: Boolean,
      default: false
    },
    isVideo: {
      type: Boolean,
      default: false
    }
    // isMp3:{
    //   type: Boolean,
    //   default: false
    // },
  },
  data() {
    return {
      // baseUrl: `${process.env.VUE_APP_BASE_URL}/service-admin/admin/file/upload`,
      baseUrl: '',
      myUrl: '',
      videoFlag: false, // 进度条
      videoUploadPercent: null
    }
  },
  mounted() {
    this.baseUrl = environment.upLoadPath()
    this.myUrl = this.imageurl
  },
  methods: {
    beforeAvatarUpload(file) {
      // 上传前的函数
      const size = Math.floor(file.size)
      if (size > 50 * 1024 * 1024) {
        // alert("请选择5M以内的图片");
        this.$message.error('请选择50M以内的文件')
        return false
      }
      if (this.isVideo) {
        if (file.type !== 'video/mp4') {
          this.$message.error('请选择MAP4格式的文件')
          return false
        }
      }
      // if (this.isMp3) {
      //   console.log(file)
      //   const isAudio = file.type === "audio/mp3" || file.type === "audio/mpeg";
      //   if (!isAudio) {
      //     this.$message.error('请选择MP3格式的文件')
      //     return false
      //   }
      // }

      //  if(size > 5*1024*1024){}
    },
    handleAvatarSuccess(res, file) {
      this.videoFlag = false

      if (res.code === 1) {
        return this.$message.error(res.message || '文件过大')
      }
      this.myUrl = URL.createObjectURL(file.raw)
      if (this.isVideo) {
        // if(file.type=""){

        // }
        this.myUrl = res.data
      } else {
        this.myUrl = URL.createObjectURL(file.raw)
      }
      this.$emit('upLoadImage', res.data)
    },
    fail(err, file) {
      this.videoFlag = false
      this.$message.error(err || '服务器错误，请稍后重试')
    },
    uploadVideoProcess(event, file, fileList) {
      this.videoFlag = true
      this.videoUploadPercent = file.percentage
    },
    init(url) {
      this.myUrl = url
    },
    onHandelImageSelect(e, file) {
      // console.log("changeImage",file)
      this.$emit('changeImage', e, file)
    }
  }
}
</script>
<style lang="scss" scoped>
.avatar-uploader {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #999999;
  margin-left: 10px;
  // border-radius: 10px;

  .round {
    // border-radius: 50%;
  }
}
.pic {
  border: none;
}
::v-deep .avatar-uploader-icon{
  width: 40px;
  height: 40px;
  line-height: 40px;
}
</style>
